
/**
 * UUID validation utilities to prevent "invalid input syntax for type uuid" errors
 */

export const isValidUUID = (uuid: string | null | undefined): boolean => {
  if (!uuid || uuid === 'null' || uuid === 'undefined') return false;
  
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

export const sanitizeUUID = (uuid: string | null | undefined): string | null => {
  if (!uuid || uuid === 'null' || uuid === 'undefined' || uuid.trim() === '') {
    return null;
  }
  
  return isValidUUID(uuid) ? uuid : null;
};

export const validateUserSession = (user: any): boolean => {
  return user && user.id && isValidUUID(user.id);
};
